import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, MapPin, Truck, Snowflake, ShieldCheck } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer data-testid="site-footer" className="bg-[#0A192F] text-white">
      <div className="container-max px-4 md:px-8 py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="mb-5 inline-block bg-white/95 rounded-2xl p-4 shadow-lg">
              <img src="/logo.png" alt="Midye Merkezi" className="h-32 w-auto object-contain" />
            </div>
            <p className="text-slate-300 leading-relaxed text-sm max-w-sm">
              {settings.footer_description}
            </p>
            <div className="flex gap-3 mt-6">
              {[
                { icon: Snowflake, label: "Soğuk Zincir" },
                { icon: Truck, label: "Hızlı Kargo" },
                { icon: ShieldCheck, label: "Güvenli Ödeme" },
              ].map(({ icon: Icon, label }) => (
                <div key={label} className="flex items-center gap-1.5 text-xs bg-white/5 rounded-full px-3 py-1.5 text-slate-200">
                  <Icon size={13} /> {label}
                </div>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="overline text-white/60 mb-4">Kurumsal</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/hakkimizda" className="text-slate-300 hover:text-white">Hakkımızda</Link></li>
              <li><Link to="/iletisim" className="text-slate-300 hover:text-white">İletişim</Link></li>
              <li><Link to="/blog" className="text-slate-300 hover:text-white">Blog</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline text-white/60 mb-4">Kategoriler</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/urunler/kucuk-boy-midye" className="text-slate-300 hover:text-white">Küçük Boy</Link></li>
              <li><Link to="/urunler/orta-boy-midye" className="text-slate-300 hover:text-white">Orta Boy</Link></li>
              <li><Link to="/urunler/buyuk-boy-midye" className="text-slate-300 hover:text-white">Büyük Boy</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline text-white/60 mb-4">İletişim</div>
            <ul className="space-y-3 text-sm text-slate-300">
              <li className="flex items-center gap-3"><Phone size={15} className="text-[#0077B6]" /> {settings.contact_phone}</li>
              <li className="flex items-center gap-3"><MessageCircle size={15} className="text-[#0077B6]" /> WhatsApp Sipariş</li>
              <li className="flex items-center gap-3"><Mail size={15} className="text-[#0077B6]" /> {settings.contact_email}</li>
              <li className="flex items-start gap-3"><MapPin size={15} className="text-[#0077B6] mt-1" /> {settings.contact_address}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <div>© {new Date().getFullYear()} Midye Merkezi. Tüm hakları saklıdır.</div>
          <div className="flex items-center gap-2">
            <span>Powered by</span>
            <a
              href="https://wa.me/905392197985/"
              target="_blank"
              rel="noreferrer"
              data-testid="pegga-link"
              className="font-semibold text-white hover:text-[#0077B6] transition-colors"
            >
              PEGGA Yazılım ve Web Hizmetleri
            </a>
          </div>
          <div>midyemerkezi.com.tr</div>
        </div>
      </div>
    </footer>
  );
}
